module.exports = __webpack_public_path__ + "img/chinesecompany222.912698ba.png";